import { addMonths, format, startOfMonth } from 'date-fns';
import daLocale from 'date-fns/locale/da';

export const currentDate = format(new Date(), 'DD-MM-YYYY');

export const getNextStartingMonthDkLocale = (month: number, now = new Date()) => {
    const date = format(startOfMonth(addMonths(now, month)), 'DD. MMMM YYYY', {
        locale: daLocale
    });

    if (date[0] === '0') return date.slice(1);
    return date;
};
export const getNextStartingMonth = (month: number, now = new Date()) =>
    format(startOfMonth(addMonths(now, month)), 'DD-MM-YYYY');

function createArray(length: number) {
    const result: number[] = [];

    for (let index = 0; index < length; index++) {
        result.push(index);
    }

    return result;
}

export const getListOfNextStartingMonths = (now = new Date()) => {
    return createArray(12).map((_, i) => {
        const label = getNextStartingMonthDkLocale(i + 2, now);
        const value = getNextStartingMonth(i + 2, now);
        return {
            value,
            label
        };
    });
};

export const formatPayloadDate = (date: string) =>
    date
        .split('-')
        .reverse()
        .join('-');
